import { LineSkeleton } from 'components/base/Skeletons';
import { StyledListSkeleton } from './IterationSummary.style';
import { Stack } from '@mui/material';
import { CircleSkeleton } from '@linearb/linui-common';

const ListSkeleton = () => {
  const shouldShowBullet = (index: number) =>
    index % (Math.random() < 0.5 ? 3 : 4) === 0;
  return (
    <StyledListSkeleton>
      <Stack marginBottom={4}>
        <LineSkeleton size={40} />
      </Stack>
      <Stack spacing={2}>
        {Array.from({ length: 16 }, (_, index) => (
          <Stack key={index} direction='row' spacing={1.5} alignItems='center'>
            <Stack width={20}>
              {shouldShowBullet(index) && <CircleSkeleton size={15} />}
            </Stack>
            <LineSkeleton isRandomSize />
          </Stack>
        ))}
      </Stack>
    </StyledListSkeleton>
  );
};

export default ListSkeleton;
